import React from 'react';
import { ListItem, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
    useDensity,
    formatNumber,
    formatTimestamp,
    formatChipText,
    StatusBadge,
} from './SharedFrames';
import { toneForSeverity } from '../strategyEventFeed';

const EventFeedItem = ({ event, divider }) => {
    const { compact } = useDensity();
    const commentary = event?.meta?.commentary || null;
    const phase = event?.meta?.phase || null;
    const regime = event?.meta?.regime || null;
    const decision = event?.meta?.decision || null;
    const symbol =
        event?.meta?.symbol ||
        event?.meta?.positionSymbol ||
        event?.meta?.exitedSymbol ||
        null;
    const adxValue = event?.meta?.adx;

    return (
        <ListItem
            disableGutters
            sx={(theme) => ({
                alignItems: 'flex-start',
                py: compact ? 1 : 1.15,
                borderBottom: divider ? `1px solid ${alpha(theme.palette.divider, 0.7)}` : 'none',
            })}
        >
            <Stack spacing={compact ? 0.65 : 0.8} sx={{ width: '100%' }}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={1}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', sm: 'flex-start' }}
                >
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                        {event.message || '—'}
                    </Typography>
                    <StatusBadge
                        label={event?.severity || 'info'}
                        tone={toneForSeverity(event?.severity)}
                    />
                </Stack>
                <Typography variant="caption" color="text.secondary">
                    {formatTimestamp(event.occurredAt)}
                </Typography>
                {commentary ? (
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
                        {commentary}
                    </Typography>
                ) : null}
                {(decision || phase || regime || symbol || adxValue != null) ? (
                    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
                        {decision ? (
                            <StatusBadge label={formatChipText(decision)} tone="primary" />
                        ) : null}
                        {phase ? <StatusBadge status={phase} /> : null}
                        {regime ? (
                            <StatusBadge label={`Regime ${formatChipText(regime)}`} tone="primary" />
                        ) : null}
                        {symbol ? <StatusBadge label={symbol} tone="default" /> : null}
                        {adxValue != null ? (
                            <StatusBadge label={`ADX ${formatNumber(adxValue, 1)}`} tone="default" />
                        ) : null}
                    </Stack>
                ) : null}
            </Stack>
        </ListItem>
    );
};

export default EventFeedItem;
